import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatDrawer, MatSidenavModule } from '@angular/material/sidenav';
import { RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { AppState } from 'src/app/core/store/app.state';
import {
  selectGuardianAvatar,
  selectIsLoggedInUserAccountHolder,
} from 'src/app/core/store/guardian/guardian.selectors';
import { LogoutConfirmationModalComponent } from 'src/app/features/authentication/components/logout-confirmation/logout-confirmation.component';
import { AvatarComponent } from 'src/app/shared/components/avatar/avatar.component';
import { environment } from 'src/environments/environment';
import { FeatureFlagService } from '../../services/feature-flags/feature-flag.service';
import { IconComponent } from '../../../shared/components/icon/icon.component';
@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    MatSidenavModule,
    MatButtonModule,
    MatDividerModule,
    AvatarComponent,
    IconComponent,
  ],
})
export class SideMenuComponent {
  @Input() drawer!: MatDrawer;
  @Output() closeEvent = new EventEmitter<void>();

  private readonly store: Store<AppState> = inject(Store<AppState>);
  private readonly authService = inject(AuthService);
  private readonly dialog = inject(MatDialog);
  private readonly featureFlags = inject(FeatureFlagService);

  currentApplicationVersion = environment.appVersion;

  private readonly showFinance = toSignal(this.store.select(selectIsLoggedInUserAccountHolder), {
    initialValue: false,
  });

  navItems = computed(() => {
    const financeItem = {
      label: 'Finance',
      link: '/payments',
    };
    const baseItems = [
      {
        label: 'Manage my family',
        link: '/manage-family',
      },
      {
        label: 'Help and support',
        link: '/help',
      },
      ...(this.featureFlags.get('library') ? [{ label: 'Library', link: '/library' }] : []),
    ];

    if (this.showFinance()) {
      //finance item should be first in the list if it is shown
      return [financeItem, ...baseItems];
    }

    return [...baseItems];
  });

  formatUserName(userName: string | undefined): string {
    if (!userName) {
      return '';
    }

    const trimmed = userName.trim();

    if (trimmed.includes(' ')) {
      return trimmed;
    }

    const parts = trimmed.match(/[A-Z][a-z]+/g);

    if (parts && parts.length >= 2) {
      return parts.join(' ');
    }

    return trimmed;
  }

  closeDrawer() {
    if (this.drawer) {
      this.drawer.close();
    }
    this.closeEvent.emit();
  }

  parent$ = this.store.select(selectGuardianAvatar(74));

  logout(): void {
    this.dialog.open(LogoutConfirmationModalComponent, {
      height: '480px',
      width: '90dvh',
    });
  }

  onLogoutConfirm(): void {
    this.authService.logout();
  }

  onLogoutCancel(): void {}
}
